module.exports = __webpack_public_path__ + "static/media/是否有去空曠處避難.6bd84a4d.xlsx";